// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MediaSFU .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
  }
  
  .MediaSFU .modal-title {
    font-size: 18px;
    font-weight: bold;
    color: black;
  }
  
  .MediaSFU .btn-close {
    padding: 5px;
    cursor: pointer;
  }
  
  .MediaSFU .container {
    display: flex;
    width: 100%;
    flex-direction: row;
    margin-top: 0px;
  }
  
  .MediaSFU .buttonContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    border-radius: 5px;
    margin-right: 4px;
    font-size: medium;
    border: none;
  }
  
  .MediaSFU .buttonContainer:hover {
    cursor: pointer;
  }
  
  .MediaSFU .verticalButton {
    flex-direction: column;
  }
  
  .MediaSFU .buttonText {
    font-size: 12px;
    margin-top: 5px;
  }
  
  .MediaSFU .modal-body {
    flex: 1;
  }
  
  .MediaSFU .form-group {
    margin-bottom: 20px;
  }
  
  .MediaSFU .label {
    font-size: 14px;
    color: black;
    margin-bottom: 5px;
    font-weight: bold;
    padding-right: 10px;
  }
  
  .MediaSFU .hr {
    height: 1px;
    background-color: black;
    margin-top: 5px;
    margin-bottom: 5px;
  }
  
  .MediaSFU .sep {
    height: 1px;
    background-color: white;
    margin-top: 0;
    margin-bottom: 0;
  }
  
  .MediaSFU .modal-footer {
    margin-top: 10px;
    display: flex;
    justify-content: flex-end;
  }
  
  .MediaSFU .btn-apply-settings {
    padding: 5px;
    border-radius: 5px;
    justify-content: center;
    align-items: center;
    background-color: black;
    color: white;
    font-size: 14px;
    cursor: pointer;
  }
  
  .MediaSFU .customButtonsContainer {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: left;
  }
  
  .MediaSFU .customButton {
    width: 100%;
    margin: 10px 0;
    padding: 10px;
    border-radius: 5px;
    background-color: transparent;
    align-items: left;
    justify-content: left;
    border: none;
  }
  
  .MediaSFU .buttonContent {
    display: flex;
    align-items: left;
    justify-content: left;
  }
  
  .MediaSFU .customButtonIcon {
    font-size: 20px;
    color: #000000;
    margin-right: 4px;
  }
  
  .MediaSFU .customButtonText {
    color: #000000;
  }
  
  .MediaSFU #whiteboardCanvas {
    border: 1px solid #000;
    cursor: crosshair;
    background-color: white;
  }
  
  .MediaSFU .resize-handle,
  .MediaSFU .move-handle {
    width: 8px;
    height: 8px;
    background: red;
    position: absolute;
  }
  
  .MediaSFU .move-handle {
    background: blue;
  }
  
  .MediaSFU #textInput {
    display: none;
    position: absolute;
    z-index: 10;
    width: 200px;
  }
  
  .MediaSFU .shape-icon {
    width: 20px;
    height: 20px;
    color: white;
  }
  
  .MediaSFU .toolbar .btn-group button,
  .MediaSFU .toolbar .dropdown-menu a {
    font-size: 0.8rem;
    padding: 5px 10px;
    margin: 0 2px;
    border-radius: 4px;
    transition: background-color 0.2s;
  }
  
  .MediaSFU .toolbar .dropdown-menu a {
    background-color: transparent;
    color: rgb(27, 26, 26);
  }
  
  .MediaSFU .toolbar .btn-group button:hover,
  .MediaSFU .toolbar .dropdown-menu a:hover {
    background-color: #e3e7eb;
  }
  
  .MediaSFU .toolbar .btn-group button.active {
    background-color: #454d55;
  }
  
  .MediaSFU .toolbarScreen .btn-group button,
  .MediaSFU .toolbarScreen .dropdown-menu a {
    font-size: 0.8rem;
    padding: 5px 10px;
    margin: 1px 2px;
    border-radius: 4px;
    transition: background-color 0.2s;
    background-color: transparent;
    color: "black";
  }
  
  .MediaSFU .toolbarScreen .btn-group button {
    color: rgb(6, 6, 6);
    border: none;
  }
  
  .MediaSFU .toolbarScreen .dropdown-menu a {
    background-color: transparent;
    color: rgb(27, 26, 26);
  }
  
  .MediaSFU .toolbarScreen .btn-group button.active {
    background-color: #454d55;
  }
  
  .MediaSFU #toolbar,
  .MediaSFU #toolbarScreen {
    transition: display 0.3s ease-in-out;
  }
  
  .MediaSFU #toolbarToggle,
  .MediaSFU #toolbarToggleScreen {
    cursor: pointer;
    border: "2px solid black" !important;
    font-size: 0.8rem;
  }
  
  .MediaSFU #colorPicker,
  .MediaSFU #colorPickerScreen {
    font-size: 0.8rem;
    padding: 2px 2px;
    width: 32px;
    height: 32px;
  }
  
  .MediaSFU #lineTypePicker {
    font-size: 0.8rem;
    padding: 2px auto;
    width: 32px;
    height: 32px;
  }
  
  .MediaSFU .btnBoard {
    font-size: 1rem;
    padding: 2px 2px;
    width: 40px;
    height: 40px;
    margin: 2px;
  }
  
  .MediaSFU #lineTypePickerScreen {
    font-size: 0.7rem;
    padding: 2px auto;
    width: 28px;
    height: 28px;
    background-color: rgba(214, 209, 209, 0.4);
    color: #000;
    border-radius: 4px;
  }
  
  .MediaSFU .toggle-icon {
    width: 30px;
    height: 30px;
    padding: 0;
    margin: 0;
  }
  
  .MediaSFU #toggleBackground.active {
    background-color: #fdfeff;
  }
  
  .MediaSFU .annotateScreenBtn {
    background-color: #2d2e2f !important;
    border: 2px solid #000 !important;
    color: green !important;
    font-size: 0.75rem;
  }
  
  .MediaSFU .waiting-list {
    display: flex;
    flex-direction: column;
  }
  
  .MediaSFU .waiting-item {
    display: flex;
    flex-direction: row;
    margin-top: 5px;
  }
  
  .MediaSFU .col7 {
    flex: 5;
    justify-content: center;
  }
  
  .MediaSFU .col2 {
    flex: 2;
    align-items: center;
    justify-content: center;
  }
  
  .MediaSFU .col1 {
    flex: 1;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/mediasfuComponents/MediasfuCSS.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,8BAA8B;IAC9B,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,6BAA6B;IAC7B,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;;IAEE,UAAU;IACV,WAAW;IACX,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;EACd;;EAEA;;IAEE,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,iCAAiC;EACnC;;EAEA;IACE,6BAA6B;IAC7B,sBAAsB;EACxB;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,iCAAiC;IACjC,6BAA6B;IAC7B,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,6BAA6B;IAC7B,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,oCAAoC;EACtC;;EAEA;;IAEE,eAAe;IACf,oCAAoC;IACpC,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;EACX;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,oCAAoC;IACpC,iCAAiC;IACjC,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,OAAO;IACP,uBAAuB;EACzB;;EAEA;IACE,OAAO;IACP,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,OAAO;EACT","sourcesContent":[".MediaSFU .modal-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 15px;\r\n  }\r\n  \r\n  .MediaSFU .modal-title {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    color: black;\r\n  }\r\n  \r\n  .MediaSFU .btn-close {\r\n    padding: 5px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .MediaSFU .container {\r\n    display: flex;\r\n    width: 100%;\r\n    flex-direction: row;\r\n    margin-top: 0px;\r\n  }\r\n  \r\n  .MediaSFU .buttonContainer {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 8px;\r\n    border-radius: 5px;\r\n    margin-right: 4px;\r\n    font-size: medium;\r\n    border: none;\r\n  }\r\n  \r\n  .MediaSFU .buttonContainer:hover {\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .MediaSFU .verticalButton {\r\n    flex-direction: column;\r\n  }\r\n  \r\n  .MediaSFU .buttonText {\r\n    font-size: 12px;\r\n    margin-top: 5px;\r\n  }\r\n  \r\n  .MediaSFU .modal-body {\r\n    flex: 1;\r\n  }\r\n  \r\n  .MediaSFU .form-group {\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  .MediaSFU .label {\r\n    font-size: 14px;\r\n    color: black;\r\n    margin-bottom: 5px;\r\n    font-weight: bold;\r\n    padding-right: 10px;\r\n  }\r\n  \r\n  .MediaSFU .hr {\r\n    height: 1px;\r\n    background-color: black;\r\n    margin-top: 5px;\r\n    margin-bottom: 5px;\r\n  }\r\n  \r\n  .MediaSFU .sep {\r\n    height: 1px;\r\n    background-color: white;\r\n    margin-top: 0;\r\n    margin-bottom: 0;\r\n  }\r\n  \r\n  .MediaSFU .modal-footer {\r\n    margin-top: 10px;\r\n    display: flex;\r\n    justify-content: flex-end;\r\n  }\r\n  \r\n  .MediaSFU .btn-apply-settings {\r\n    padding: 5px;\r\n    border-radius: 5px;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background-color: black;\r\n    color: white;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .MediaSFU .customButtonsContainer {\r\n    display: flex;\r\n    flex-direction: column;\r\n    flex-wrap: wrap;\r\n    justify-content: space-between;\r\n    align-items: left;\r\n  }\r\n  \r\n  .MediaSFU .customButton {\r\n    width: 100%;\r\n    margin: 10px 0;\r\n    padding: 10px;\r\n    border-radius: 5px;\r\n    background-color: transparent;\r\n    align-items: left;\r\n    justify-content: left;\r\n    border: none;\r\n  }\r\n  \r\n  .MediaSFU .buttonContent {\r\n    display: flex;\r\n    align-items: left;\r\n    justify-content: left;\r\n  }\r\n  \r\n  .MediaSFU .customButtonIcon {\r\n    font-size: 20px;\r\n    color: #000000;\r\n    margin-right: 4px;\r\n  }\r\n  \r\n  .MediaSFU .customButtonText {\r\n    color: #000000;\r\n  }\r\n  \r\n  .MediaSFU #whiteboardCanvas {\r\n    border: 1px solid #000;\r\n    cursor: crosshair;\r\n    background-color: white;\r\n  }\r\n  \r\n  .MediaSFU .resize-handle,\r\n  .MediaSFU .move-handle {\r\n    width: 8px;\r\n    height: 8px;\r\n    background: red;\r\n    position: absolute;\r\n  }\r\n  \r\n  .MediaSFU .move-handle {\r\n    background: blue;\r\n  }\r\n  \r\n  .MediaSFU #textInput {\r\n    display: none;\r\n    position: absolute;\r\n    z-index: 10;\r\n    width: 200px;\r\n  }\r\n  \r\n  .MediaSFU .shape-icon {\r\n    width: 20px;\r\n    height: 20px;\r\n    color: white;\r\n  }\r\n  \r\n  .MediaSFU .toolbar .btn-group button,\r\n  .MediaSFU .toolbar .dropdown-menu a {\r\n    font-size: 0.8rem;\r\n    padding: 5px 10px;\r\n    margin: 0 2px;\r\n    border-radius: 4px;\r\n    transition: background-color 0.2s;\r\n  }\r\n  \r\n  .MediaSFU .toolbar .dropdown-menu a {\r\n    background-color: transparent;\r\n    color: rgb(27, 26, 26);\r\n  }\r\n  \r\n  .MediaSFU .toolbar .btn-group button:hover,\r\n  .MediaSFU .toolbar .dropdown-menu a:hover {\r\n    background-color: #e3e7eb;\r\n  }\r\n  \r\n  .MediaSFU .toolbar .btn-group button.active {\r\n    background-color: #454d55;\r\n  }\r\n  \r\n  .MediaSFU .toolbarScreen .btn-group button,\r\n  .MediaSFU .toolbarScreen .dropdown-menu a {\r\n    font-size: 0.8rem;\r\n    padding: 5px 10px;\r\n    margin: 1px 2px;\r\n    border-radius: 4px;\r\n    transition: background-color 0.2s;\r\n    background-color: transparent;\r\n    color: \"black\";\r\n  }\r\n  \r\n  .MediaSFU .toolbarScreen .btn-group button {\r\n    color: rgb(6, 6, 6);\r\n    border: none;\r\n  }\r\n  \r\n  .MediaSFU .toolbarScreen .dropdown-menu a {\r\n    background-color: transparent;\r\n    color: rgb(27, 26, 26);\r\n  }\r\n  \r\n  .MediaSFU .toolbarScreen .btn-group button.active {\r\n    background-color: #454d55;\r\n  }\r\n  \r\n  .MediaSFU #toolbar,\r\n  .MediaSFU #toolbarScreen {\r\n    transition: display 0.3s ease-in-out;\r\n  }\r\n  \r\n  .MediaSFU #toolbarToggle,\r\n  .MediaSFU #toolbarToggleScreen {\r\n    cursor: pointer;\r\n    border: \"2px solid black\" !important;\r\n    font-size: 0.8rem;\r\n  }\r\n  \r\n  .MediaSFU #colorPicker,\r\n  .MediaSFU #colorPickerScreen {\r\n    font-size: 0.8rem;\r\n    padding: 2px 2px;\r\n    width: 32px;\r\n    height: 32px;\r\n  }\r\n  \r\n  .MediaSFU #lineTypePicker {\r\n    font-size: 0.8rem;\r\n    padding: 2px auto;\r\n    width: 32px;\r\n    height: 32px;\r\n  }\r\n  \r\n  .MediaSFU .btnBoard {\r\n    font-size: 1rem;\r\n    padding: 2px 2px;\r\n    width: 40px;\r\n    height: 40px;\r\n    margin: 2px;\r\n  }\r\n  \r\n  .MediaSFU #lineTypePickerScreen {\r\n    font-size: 0.7rem;\r\n    padding: 2px auto;\r\n    width: 28px;\r\n    height: 28px;\r\n    background-color: rgba(214, 209, 209, 0.4);\r\n    color: #000;\r\n    border-radius: 4px;\r\n  }\r\n  \r\n  .MediaSFU .toggle-icon {\r\n    width: 30px;\r\n    height: 30px;\r\n    padding: 0;\r\n    margin: 0;\r\n  }\r\n  \r\n  .MediaSFU #toggleBackground.active {\r\n    background-color: #fdfeff;\r\n  }\r\n  \r\n  .MediaSFU .annotateScreenBtn {\r\n    background-color: #2d2e2f !important;\r\n    border: 2px solid #000 !important;\r\n    color: green !important;\r\n    font-size: 0.75rem;\r\n  }\r\n  \r\n  .MediaSFU .waiting-list {\r\n    display: flex;\r\n    flex-direction: column;\r\n  }\r\n  \r\n  .MediaSFU .waiting-item {\r\n    display: flex;\r\n    flex-direction: row;\r\n    margin-top: 5px;\r\n  }\r\n  \r\n  .MediaSFU .col7 {\r\n    flex: 5;\r\n    justify-content: center;\r\n  }\r\n  \r\n  .MediaSFU .col2 {\r\n    flex: 2;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n  \r\n  .MediaSFU .col1 {\r\n    flex: 1;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
